import { render, staticRenderFns } from "./RoadTaxDetail.vue?vue&type=template&id=b79a36c2&"
import script from "./RoadTaxDetail.vue?vue&type=script&lang=js&"
export * from "./RoadTaxDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports